(function iefe(w, d) {
    const inputs = d.querySelectorAll('.validatethis');
    const replyforms = d.querySelectorAll('.reply-form');

    if (!inputs) {
        return;
    }

    function init() {
        inputs.forEach((input) => {
            const error = d.getElementById(input.getAttribute('aria-describedby'));
            const text = d.getElementById(`${input.getAttribute('aria-describedby')}-text`);

            // Options for the observer (which mutations to observe)
            const config = { attributes: true, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            const callback = (mutationList) => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'attributes') {
                        error.innerHTML = text.innerHTML;
                    }
                }
            };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(error, config);
        });
    }

    replyforms.forEach((reply) => {
        // Options for the observer (which mutations to observe)
        const config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === 'attributes') {
                    init();
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(reply, config);
    });

    init();
}(window, document));
